import Profile from "../../components/Profile/Profile";
import { useLoginModalContext } from "../../app/context/LoginModal";
import React from "react";

const UserProfile = () => {
  const { setShowLoginModal } = useLoginModalContext();

  const loginModalHandler = () => {
    setShowLoginModal(true);
  };
  return (
    <div className="full-sec"><div className="right-sec">
        <Profile />
      </div>
    </div>
  );
};

export default UserProfile;
